import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=55968aaa&scoped=true&"
import script from "./clientes.js?vue&type=script&lang=js&"
export * from "./clientes.js?vue&type=script&lang=js&"
import style0 from "./Clientes.vue?vue&type=style&index=0&id=55968aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55968aaa",
  null
  
)

component.options.__file = "Clientes.vue"
export default component.exports